export enum EventTopicFields {
    NAME = 'name',
    PARTICIPANT_TYPES = 'participantTypes',
}
